module.exports = __webpack_public_path__ + "img/bg_auth_tablet.1e25b130.svg";